export enum OrderDirection {
    ASC = 'asc',
    DESC = 'desc',
}

export interface SortOrder {
    column: string;
    direction: OrderDirection;
}
